import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

import Tab from '../Tab';
import moment from "moment";
import {getConditionLabel} from "../../../Services/ConditionalService";

class Tabs extends React.Component {
  constructor(props) {
    super(props);
  }

  getNewActiveTabLabel = (index) => {
    const { children, api, configuration } = this.props;
    const elements = [...children];
    const oldElement = children[index];
    elements.splice(index, 1);
    const newElement = elements[index] || elements[index-1];
    let newLabel = newElement ? newElement.props.label : 'Dynamic Form';
    const newGroupId = newElement.props.data ? newElement.props.data.groupId : null;
    if (newGroupId && oldElement.props.data.groupId === newGroupId) {
      let groupElements = [];
      angular.forEach(elements, (item) => {
        if (item.props.data && (item.props.data.groupId === newGroupId)) {
          groupElements.push(item);
        }
      });
      groupElements.forEach((item, indexElement) => {
        if (moment(item.props.data.time).isSame(newElement.props.data.time)) {
          const workOrderNumber = groupElements.length <= 1 ? '' : `(${indexElement + 1})`;
          const { section, id } = api.getFieldData(item.props.data.groupId);
          const field = configuration.sections.items[section].fields.items[id];
          const conditionLabel = getConditionLabel(field, item.props.data.triggerId);
          newLabel = `Work Order for ${item.props.data.label}: ${conditionLabel} ${workOrderNumber}`;
          return newLabel;
        }
      });
    }
    return newLabel;
  }

  onClickCancel = (data, index) => {
    const { onClickCancel } = this.props;
    const newLabel = this.getNewActiveTabLabel(index);
    onClickCancel(data, newLabel);
  };

  onClickTabItem = (tab) => {
    const { onClick } = this.props;
    onClick(tab);
  };

  render() {
    const {
      onClickTabItem,
      onClickCancel,
      props: {
        children,
        activeTab,
      },
    } = this;

    return (
      <div>
        <ol className={'Tabs__List'}>
          {children.map((child, index) => {
            const { label, data } = child.props;
            return (
              <Tab
                activeTab={activeTab}
                key={label}
                label={label}
                groupId={data ? data.groupId : null}
                triggerId={data ? data.triggerId : null}
                time={data ? data.time : null}
                index={index}
                onClick={onClickTabItem}
                onClickCancel={onClickCancel}
              />
            );
          })}
        </ol>
        <div>
          {children.map((child) => {
            if (child.props.label !== activeTab) return undefined;
            return child.props.children;
          })}
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.instanceOf(Array).isRequired,
  activeTab: PropTypes.string.isRequired,
}

export default Tabs;